import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {LocationMiscellaneousCertificationModel} from '@/sdk/models/location/location-miscellaneous-certification.model';
import {SiteLocationService} from '@/views/shared/services/site-location.service';
import {Component, Prop} from 'vue-property-decorator';
import JunctionBoxTerminalBlockComponent from '../junction-box-terminal-block/junction-box-terminal-block.component';
import SaveTerminalBlockDialogComponent from '../save-terminal-block-dialog/save-terminal-block-dialog.component';

@Component({
    name: 'MiscellaneousCertificationComponent',
    components: {
        JunctionBoxTerminalBlockComponent,
        SaveTerminalBlockDialogComponent,
    },
})
export default class MiscellaneousCertificationComponent extends VueWrapper {
    @Prop({
        required: false,
        default: false,
    })
    readOnly!: boolean;

    public siteLocationsSrv: SiteLocationService = new SiteLocationService();

    public selectedMiscCertification: string = 'IntrinsicSafety';

    public selectYesNo = [
        {key: 'yes', value: 'Yes'},
        {key: 'no', value: 'No'},
    ];

    public selectKhzMhz = [
        {id: 'khz', value: 'kHz'},
        {id: 'mhz', value: 'MHz'},
    ];

    public selectTorqueType = [
        {id: 'constant', value: 'Constant Torque'},
        {id: 'variable', value: 'Variable Torque'},
    ];

    public get readOnlyFlag(): boolean {
        return this.readOnly || false;
    }

    public validateNumber(evt: any) {
        evt = evt ? evt : window.event;
        const expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
            evt.preventDefault();
        } else {
            return true;
        }
    }

    public get miscellaneousCertification(): LocationMiscellaneousCertificationModel | null {
        // Check if we have an equipment detail with miscellaneous certification
        if (this.siteLocationsSrv.selectedLcoation?.equipmentDetail?.miscellaneousCertification) {
            return this.siteLocationsSrv.selectedLcoation.equipmentDetail.miscellaneousCertification;
        }
        // Check if we have a junction box detail with miscellaneous certification
        if (this.siteLocationsSrv.selectedLcoation?.junctionBoxDetail?.miscellaneousCertification) {
            return this.siteLocationsSrv.selectedLcoation.junctionBoxDetail.miscellaneousCertification;
        }
        return null;
    }

    public get junctionBoxId(): string | null {
        return this.siteLocationsSrv.selectedLcoation?.id || null;
    }
}
